document.addEventListener('latte:init', init);

function init() {
	if($('.video-background').length > 0) {
        $.getScript("//players.brightcove.net/1107601868001/r1lYjyDwux_default/index.min.js").done(function (script) {
            $('.video-background').each(function() {
            	var videoId = $(this).attr('data-videoId');
            	var homepagePlayer = videojs(videoId);
            	homepagePlayer.ready(function(){
            	    homepagePlayer = this;
            	    homepagePlayer.play();
            	});
            });
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./public/js/billboardVideo.js
// module id = 66
// module chunks = 0